// source: tprmquestionnaire/questionnaire_internal.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var tprmquestionnaire_tprmquestionnaire_pb = require('../tprmquestionnaire/tprmquestionnaire_pb.js');
goog.object.extend(proto, tprmquestionnaire_tprmquestionnaire_pb);
var authz_annotations_pb = require('../authz/annotations_pb.js');
goog.object.extend(proto, authz_annotations_pb);
goog.exportSymbol('proto.tprmquestionnaire.ANSWER_OUTCOME', null, global);
goog.exportSymbol('proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.EnsureQuestionContextRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.GetQuestionnaireQuestionsRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.ImportDestination', null, global);
goog.exportSymbol('proto.tprmquestionnaire.QuestionWithContext', null, global);
goog.exportSymbol('proto.tprmquestionnaire.QuestionWithContext.Attachment', null, global);
goog.exportSymbol('proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental', null, global);
goog.exportSymbol('proto.tprmquestionnaire.QuestionnaireAnswerGrade', null, global);
goog.exportSymbol('proto.tprmquestionnaire.QuestionnaireDirection', null, global);
goog.exportSymbol('proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.SaveQuestionnaireAnswersResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.SaveQuestionnaireGradesRequest', null, global);
goog.exportSymbol('proto.tprmquestionnaire.SaveQuestionnaireGradesResponse', null, global);
goog.exportSymbol('proto.tprmquestionnaire.WriteAnswerAttachment', null, global);
goog.exportSymbol('proto.tprmquestionnaire.WriteAnswerSource', null, global);
goog.exportSymbol('proto.tprmquestionnaire.WriteFormOption', null, global);
goog.exportSymbol('proto.tprmquestionnaire.WriteFormQuestion', null, global);
goog.exportSymbol('proto.tprmquestionnaire.WriteFormSection', null, global);
goog.exportSymbol('proto.tprmquestionnaire.WriteQuestionnaireAnswer', null, global);
goog.exportSymbol('proto.tprmquestionnaire.WriteSupplementalInput', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.WriteSupplementalInput = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.WriteSupplementalInput, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.WriteSupplementalInput.displayName = 'proto.tprmquestionnaire.WriteSupplementalInput';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.WriteFormOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.WriteFormOption.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.WriteFormOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.WriteFormOption.displayName = 'proto.tprmquestionnaire.WriteFormOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.WriteFormQuestion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.WriteFormQuestion.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.WriteFormQuestion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.WriteFormQuestion.displayName = 'proto.tprmquestionnaire.WriteFormQuestion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.WriteFormSection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.WriteFormSection.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.WriteFormSection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.WriteFormSection.displayName = 'proto.tprmquestionnaire.WriteFormSection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.displayName = 'proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse.displayName = 'proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest.displayName = 'proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.GetQuestionnaireQuestionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.GetQuestionnaireQuestionsRequest.displayName = 'proto.tprmquestionnaire.GetQuestionnaireQuestionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.displayName = 'proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.QuestionWithContext = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.QuestionWithContext.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.QuestionWithContext, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.QuestionWithContext.displayName = 'proto.tprmquestionnaire.QuestionWithContext';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental.displayName = 'proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.QuestionWithContext.Attachment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.QuestionWithContext.Attachment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.QuestionWithContext.Attachment.displayName = 'proto.tprmquestionnaire.QuestionWithContext.Attachment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.EnsureQuestionContextRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.EnsureQuestionContextRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.EnsureQuestionContextRequest.displayName = 'proto.tprmquestionnaire.EnsureQuestionContextRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.WriteAnswerSource = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.WriteAnswerSource, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.WriteAnswerSource.displayName = 'proto.tprmquestionnaire.WriteAnswerSource';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.WriteAnswerAttachment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.WriteAnswerAttachment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.WriteAnswerAttachment.displayName = 'proto.tprmquestionnaire.WriteAnswerAttachment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.WriteQuestionnaireAnswer.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.WriteQuestionnaireAnswer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.WriteQuestionnaireAnswer.displayName = 'proto.tprmquestionnaire.WriteQuestionnaireAnswer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest.displayName = 'proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.SaveQuestionnaireAnswersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.SaveQuestionnaireAnswersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.SaveQuestionnaireAnswersResponse.displayName = 'proto.tprmquestionnaire.SaveQuestionnaireAnswersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.QuestionnaireAnswerGrade = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.QuestionnaireAnswerGrade.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.QuestionnaireAnswerGrade, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.QuestionnaireAnswerGrade.displayName = 'proto.tprmquestionnaire.QuestionnaireAnswerGrade';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.SaveQuestionnaireGradesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.tprmquestionnaire.SaveQuestionnaireGradesRequest.repeatedFields_, null);
};
goog.inherits(proto.tprmquestionnaire.SaveQuestionnaireGradesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.SaveQuestionnaireGradesRequest.displayName = 'proto.tprmquestionnaire.SaveQuestionnaireGradesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tprmquestionnaire.SaveQuestionnaireGradesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tprmquestionnaire.SaveQuestionnaireGradesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tprmquestionnaire.SaveQuestionnaireGradesResponse.displayName = 'proto.tprmquestionnaire.SaveQuestionnaireGradesResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.WriteSupplementalInput.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.WriteSupplementalInput.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.WriteSupplementalInput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.WriteSupplementalInput.toObject = function(includeInstance, msg) {
  var f, obj = {
    kind: jspb.Message.getFieldWithDefault(msg, 1, 0),
    label: jspb.Message.getFieldWithDefault(msg, 2, ""),
    required: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    isList: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.WriteSupplementalInput}
 */
proto.tprmquestionnaire.WriteSupplementalInput.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.WriteSupplementalInput;
  return proto.tprmquestionnaire.WriteSupplementalInput.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.WriteSupplementalInput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.WriteSupplementalInput}
 */
proto.tprmquestionnaire.WriteSupplementalInput.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.tprmquestionnaire.SupplementalInputKind} */ (reader.readEnum());
      msg.setKind(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequired(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.WriteSupplementalInput.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.WriteSupplementalInput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.WriteSupplementalInput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.WriteSupplementalInput.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKind();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRequired();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getIsList();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional SupplementalInputKind kind = 1;
 * @return {!proto.tprmquestionnaire.SupplementalInputKind}
 */
proto.tprmquestionnaire.WriteSupplementalInput.prototype.getKind = function() {
  return /** @type {!proto.tprmquestionnaire.SupplementalInputKind} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.tprmquestionnaire.SupplementalInputKind} value
 * @return {!proto.tprmquestionnaire.WriteSupplementalInput} returns this
 */
proto.tprmquestionnaire.WriteSupplementalInput.prototype.setKind = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.tprmquestionnaire.WriteSupplementalInput.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.WriteSupplementalInput} returns this
 */
proto.tprmquestionnaire.WriteSupplementalInput.prototype.setLabel = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.WriteSupplementalInput} returns this
 */
proto.tprmquestionnaire.WriteSupplementalInput.prototype.clearLabel = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.WriteSupplementalInput.prototype.hasLabel = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool required = 3;
 * @return {boolean}
 */
proto.tprmquestionnaire.WriteSupplementalInput.prototype.getRequired = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tprmquestionnaire.WriteSupplementalInput} returns this
 */
proto.tprmquestionnaire.WriteSupplementalInput.prototype.setRequired = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool is_list = 4;
 * @return {boolean}
 */
proto.tprmquestionnaire.WriteSupplementalInput.prototype.getIsList = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tprmquestionnaire.WriteSupplementalInput} returns this
 */
proto.tprmquestionnaire.WriteSupplementalInput.prototype.setIsList = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.WriteFormOption.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.WriteFormOption.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.WriteFormOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.WriteFormOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.WriteFormOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    label: jspb.Message.getFieldWithDefault(msg, 1, ""),
    displayOrder: jspb.Message.getFieldWithDefault(msg, 2, 0),
    supplementalList: jspb.Message.toObjectList(msg.getSupplementalList(),
    proto.tprmquestionnaire.WriteSupplementalInput.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.WriteFormOption}
 */
proto.tprmquestionnaire.WriteFormOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.WriteFormOption;
  return proto.tprmquestionnaire.WriteFormOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.WriteFormOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.WriteFormOption}
 */
proto.tprmquestionnaire.WriteFormOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisplayOrder(value);
      break;
    case 3:
      var value = new proto.tprmquestionnaire.WriteSupplementalInput;
      reader.readMessage(value,proto.tprmquestionnaire.WriteSupplementalInput.deserializeBinaryFromReader);
      msg.addSupplemental(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.WriteFormOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.WriteFormOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.WriteFormOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.WriteFormOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDisplayOrder();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getSupplementalList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.tprmquestionnaire.WriteSupplementalInput.serializeBinaryToWriter
    );
  }
};


/**
 * optional string label = 1;
 * @return {string}
 */
proto.tprmquestionnaire.WriteFormOption.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.WriteFormOption} returns this
 */
proto.tprmquestionnaire.WriteFormOption.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 display_order = 2;
 * @return {number}
 */
proto.tprmquestionnaire.WriteFormOption.prototype.getDisplayOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.WriteFormOption} returns this
 */
proto.tprmquestionnaire.WriteFormOption.prototype.setDisplayOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated WriteSupplementalInput supplemental = 3;
 * @return {!Array<!proto.tprmquestionnaire.WriteSupplementalInput>}
 */
proto.tprmquestionnaire.WriteFormOption.prototype.getSupplementalList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.WriteSupplementalInput>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.WriteSupplementalInput, 3));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.WriteSupplementalInput>} value
 * @return {!proto.tprmquestionnaire.WriteFormOption} returns this
*/
proto.tprmquestionnaire.WriteFormOption.prototype.setSupplementalList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.tprmquestionnaire.WriteSupplementalInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.WriteSupplementalInput}
 */
proto.tprmquestionnaire.WriteFormOption.prototype.addSupplemental = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.tprmquestionnaire.WriteSupplementalInput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.WriteFormOption} returns this
 */
proto.tprmquestionnaire.WriteFormOption.prototype.clearSupplementalList = function() {
  return this.setSupplementalList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.WriteFormQuestion.repeatedFields_ = [4,5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.WriteFormQuestion.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.WriteFormQuestion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.WriteFormQuestion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.WriteFormQuestion.toObject = function(includeInstance, msg) {
  var f, obj = {
    text: jspb.Message.getFieldWithDefault(msg, 1, ""),
    responseType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    displayOrder: jspb.Message.getFieldWithDefault(msg, 3, 0),
    optionsList: jspb.Message.toObjectList(msg.getOptionsList(),
    proto.tprmquestionnaire.WriteFormOption.toObject, includeInstance),
    dependsOnList: jspb.Message.toObjectList(msg.getDependsOnList(),
    tprmquestionnaire_tprmquestionnaire_pb.ConditionRule.toObject, includeInstance),
    supplementalList: jspb.Message.toObjectList(msg.getSupplementalList(),
    proto.tprmquestionnaire.WriteSupplementalInput.toObject, includeInstance),
    sourceKey: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.WriteFormQuestion}
 */
proto.tprmquestionnaire.WriteFormQuestion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.WriteFormQuestion;
  return proto.tprmquestionnaire.WriteFormQuestion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.WriteFormQuestion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.WriteFormQuestion}
 */
proto.tprmquestionnaire.WriteFormQuestion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 2:
      var value = /** @type {!proto.tprmquestionnaire.QuestionResponseType} */ (reader.readEnum());
      msg.setResponseType(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisplayOrder(value);
      break;
    case 4:
      var value = new proto.tprmquestionnaire.WriteFormOption;
      reader.readMessage(value,proto.tprmquestionnaire.WriteFormOption.deserializeBinaryFromReader);
      msg.addOptions(value);
      break;
    case 5:
      var value = new tprmquestionnaire_tprmquestionnaire_pb.ConditionRule;
      reader.readMessage(value,tprmquestionnaire_tprmquestionnaire_pb.ConditionRule.deserializeBinaryFromReader);
      msg.addDependsOn(value);
      break;
    case 6:
      var value = new proto.tprmquestionnaire.WriteSupplementalInput;
      reader.readMessage(value,proto.tprmquestionnaire.WriteSupplementalInput.deserializeBinaryFromReader);
      msg.addSupplemental(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.WriteFormQuestion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.WriteFormQuestion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.WriteFormQuestion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.WriteFormQuestion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getResponseType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getDisplayOrder();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.tprmquestionnaire.WriteFormOption.serializeBinaryToWriter
    );
  }
  f = message.getDependsOnList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      tprmquestionnaire_tprmquestionnaire_pb.ConditionRule.serializeBinaryToWriter
    );
  }
  f = message.getSupplementalList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.tprmquestionnaire.WriteSupplementalInput.serializeBinaryToWriter
    );
  }
  f = message.getSourceKey();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string text = 1;
 * @return {string}
 */
proto.tprmquestionnaire.WriteFormQuestion.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.WriteFormQuestion} returns this
 */
proto.tprmquestionnaire.WriteFormQuestion.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional QuestionResponseType response_type = 2;
 * @return {!proto.tprmquestionnaire.QuestionResponseType}
 */
proto.tprmquestionnaire.WriteFormQuestion.prototype.getResponseType = function() {
  return /** @type {!proto.tprmquestionnaire.QuestionResponseType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.tprmquestionnaire.QuestionResponseType} value
 * @return {!proto.tprmquestionnaire.WriteFormQuestion} returns this
 */
proto.tprmquestionnaire.WriteFormQuestion.prototype.setResponseType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int32 display_order = 3;
 * @return {number}
 */
proto.tprmquestionnaire.WriteFormQuestion.prototype.getDisplayOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.WriteFormQuestion} returns this
 */
proto.tprmquestionnaire.WriteFormQuestion.prototype.setDisplayOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated WriteFormOption options = 4;
 * @return {!Array<!proto.tprmquestionnaire.WriteFormOption>}
 */
proto.tprmquestionnaire.WriteFormQuestion.prototype.getOptionsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.WriteFormOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.WriteFormOption, 4));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.WriteFormOption>} value
 * @return {!proto.tprmquestionnaire.WriteFormQuestion} returns this
*/
proto.tprmquestionnaire.WriteFormQuestion.prototype.setOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.tprmquestionnaire.WriteFormOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.WriteFormOption}
 */
proto.tprmquestionnaire.WriteFormQuestion.prototype.addOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.tprmquestionnaire.WriteFormOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.WriteFormQuestion} returns this
 */
proto.tprmquestionnaire.WriteFormQuestion.prototype.clearOptionsList = function() {
  return this.setOptionsList([]);
};


/**
 * repeated ConditionRule depends_on = 5;
 * @return {!Array<!proto.tprmquestionnaire.ConditionRule>}
 */
proto.tprmquestionnaire.WriteFormQuestion.prototype.getDependsOnList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.ConditionRule>} */ (
    jspb.Message.getRepeatedWrapperField(this, tprmquestionnaire_tprmquestionnaire_pb.ConditionRule, 5));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.ConditionRule>} value
 * @return {!proto.tprmquestionnaire.WriteFormQuestion} returns this
*/
proto.tprmquestionnaire.WriteFormQuestion.prototype.setDependsOnList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.tprmquestionnaire.ConditionRule=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ConditionRule}
 */
proto.tprmquestionnaire.WriteFormQuestion.prototype.addDependsOn = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.tprmquestionnaire.ConditionRule, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.WriteFormQuestion} returns this
 */
proto.tprmquestionnaire.WriteFormQuestion.prototype.clearDependsOnList = function() {
  return this.setDependsOnList([]);
};


/**
 * repeated WriteSupplementalInput supplemental = 6;
 * @return {!Array<!proto.tprmquestionnaire.WriteSupplementalInput>}
 */
proto.tprmquestionnaire.WriteFormQuestion.prototype.getSupplementalList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.WriteSupplementalInput>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.WriteSupplementalInput, 6));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.WriteSupplementalInput>} value
 * @return {!proto.tprmquestionnaire.WriteFormQuestion} returns this
*/
proto.tprmquestionnaire.WriteFormQuestion.prototype.setSupplementalList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.tprmquestionnaire.WriteSupplementalInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.WriteSupplementalInput}
 */
proto.tprmquestionnaire.WriteFormQuestion.prototype.addSupplemental = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.tprmquestionnaire.WriteSupplementalInput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.WriteFormQuestion} returns this
 */
proto.tprmquestionnaire.WriteFormQuestion.prototype.clearSupplementalList = function() {
  return this.setSupplementalList([]);
};


/**
 * optional string source_key = 7;
 * @return {string}
 */
proto.tprmquestionnaire.WriteFormQuestion.prototype.getSourceKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.WriteFormQuestion} returns this
 */
proto.tprmquestionnaire.WriteFormQuestion.prototype.setSourceKey = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.WriteFormSection.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.WriteFormSection.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.WriteFormSection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.WriteFormSection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.WriteFormSection.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    displayOrder: jspb.Message.getFieldWithDefault(msg, 2, 0),
    dependsOnList: jspb.Message.toObjectList(msg.getDependsOnList(),
    tprmquestionnaire_tprmquestionnaire_pb.ConditionRule.toObject, includeInstance),
    questionsList: jspb.Message.toObjectList(msg.getQuestionsList(),
    proto.tprmquestionnaire.WriteFormQuestion.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.WriteFormSection}
 */
proto.tprmquestionnaire.WriteFormSection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.WriteFormSection;
  return proto.tprmquestionnaire.WriteFormSection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.WriteFormSection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.WriteFormSection}
 */
proto.tprmquestionnaire.WriteFormSection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisplayOrder(value);
      break;
    case 3:
      var value = new tprmquestionnaire_tprmquestionnaire_pb.ConditionRule;
      reader.readMessage(value,tprmquestionnaire_tprmquestionnaire_pb.ConditionRule.deserializeBinaryFromReader);
      msg.addDependsOn(value);
      break;
    case 4:
      var value = new proto.tprmquestionnaire.WriteFormQuestion;
      reader.readMessage(value,proto.tprmquestionnaire.WriteFormQuestion.deserializeBinaryFromReader);
      msg.addQuestions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.WriteFormSection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.WriteFormSection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.WriteFormSection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.WriteFormSection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDisplayOrder();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getDependsOnList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      tprmquestionnaire_tprmquestionnaire_pb.ConditionRule.serializeBinaryToWriter
    );
  }
  f = message.getQuestionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.tprmquestionnaire.WriteFormQuestion.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.tprmquestionnaire.WriteFormSection.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.WriteFormSection} returns this
 */
proto.tprmquestionnaire.WriteFormSection.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 display_order = 2;
 * @return {number}
 */
proto.tprmquestionnaire.WriteFormSection.prototype.getDisplayOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.WriteFormSection} returns this
 */
proto.tprmquestionnaire.WriteFormSection.prototype.setDisplayOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated ConditionRule depends_on = 3;
 * @return {!Array<!proto.tprmquestionnaire.ConditionRule>}
 */
proto.tprmquestionnaire.WriteFormSection.prototype.getDependsOnList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.ConditionRule>} */ (
    jspb.Message.getRepeatedWrapperField(this, tprmquestionnaire_tprmquestionnaire_pb.ConditionRule, 3));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.ConditionRule>} value
 * @return {!proto.tprmquestionnaire.WriteFormSection} returns this
*/
proto.tprmquestionnaire.WriteFormSection.prototype.setDependsOnList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.tprmquestionnaire.ConditionRule=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ConditionRule}
 */
proto.tprmquestionnaire.WriteFormSection.prototype.addDependsOn = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.tprmquestionnaire.ConditionRule, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.WriteFormSection} returns this
 */
proto.tprmquestionnaire.WriteFormSection.prototype.clearDependsOnList = function() {
  return this.setDependsOnList([]);
};


/**
 * repeated WriteFormQuestion questions = 4;
 * @return {!Array<!proto.tprmquestionnaire.WriteFormQuestion>}
 */
proto.tprmquestionnaire.WriteFormSection.prototype.getQuestionsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.WriteFormQuestion>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.WriteFormQuestion, 4));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.WriteFormQuestion>} value
 * @return {!proto.tprmquestionnaire.WriteFormSection} returns this
*/
proto.tprmquestionnaire.WriteFormSection.prototype.setQuestionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.tprmquestionnaire.WriteFormQuestion=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.WriteFormQuestion}
 */
proto.tprmquestionnaire.WriteFormSection.prototype.addQuestions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.tprmquestionnaire.WriteFormQuestion, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.WriteFormSection} returns this
 */
proto.tprmquestionnaire.WriteFormSection.prototype.clearQuestionsList = function() {
  return this.setQuestionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    description: jspb.Message.getFieldWithDefault(msg, 4, ""),
    sectionsList: jspb.Message.toObjectList(msg.getSectionsList(),
    proto.tprmquestionnaire.WriteFormSection.toObject, includeInstance),
    destination: jspb.Message.getFieldWithDefault(msg, 6, 0),
    requestingOrgName: jspb.Message.getFieldWithDefault(msg, 7, ""),
    dueDate: jspb.Message.getFieldWithDefault(msg, 8, 0),
    sourceContentId: jspb.Message.getFieldWithDefault(msg, 9, ""),
    sourceFileName: jspb.Message.getFieldWithDefault(msg, 10, ""),
    sourceMimeType: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest}
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest;
  return proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest}
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = new proto.tprmquestionnaire.WriteFormSection;
      reader.readMessage(value,proto.tprmquestionnaire.WriteFormSection.deserializeBinaryFromReader);
      msg.addSections(value);
      break;
    case 6:
      var value = /** @type {!proto.tprmquestionnaire.ImportDestination} */ (reader.readEnum());
      msg.setDestination(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestingOrgName(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDueDate(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceContentId(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceFileName(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceMimeType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSectionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.tprmquestionnaire.WriteFormSection.serializeBinaryToWriter
    );
  }
  f = message.getDestination();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getRequestingOrgName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getSourceContentId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSourceFileName();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getSourceMimeType();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest} returns this
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest} returns this
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest} returns this
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest} returns this
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated WriteFormSection sections = 5;
 * @return {!Array<!proto.tprmquestionnaire.WriteFormSection>}
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.getSectionsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.WriteFormSection>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.WriteFormSection, 5));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.WriteFormSection>} value
 * @return {!proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest} returns this
*/
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.setSectionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.tprmquestionnaire.WriteFormSection=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.WriteFormSection}
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.addSections = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.tprmquestionnaire.WriteFormSection, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest} returns this
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.clearSectionsList = function() {
  return this.setSectionsList([]);
};


/**
 * optional ImportDestination destination = 6;
 * @return {!proto.tprmquestionnaire.ImportDestination}
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.getDestination = function() {
  return /** @type {!proto.tprmquestionnaire.ImportDestination} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.tprmquestionnaire.ImportDestination} value
 * @return {!proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest} returns this
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.setDestination = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string requesting_org_name = 7;
 * @return {string}
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.getRequestingOrgName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest} returns this
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.setRequestingOrgName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 due_date = 8;
 * @return {number}
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.getDueDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest} returns this
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.setDueDate = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest} returns this
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.clearDueDate = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.hasDueDate = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string source_content_id = 9;
 * @return {string}
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.getSourceContentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest} returns this
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.setSourceContentId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string source_file_name = 10;
 * @return {string}
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.getSourceFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest} returns this
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.setSourceFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string source_mime_type = 11;
 * @return {string}
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.getSourceMimeType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest} returns this
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalRequest.prototype.setSourceMimeType = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionnaireFormId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    questionnaireRequestId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    questionnaireTemplateId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse}
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse;
  return proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse}
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireFormId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireRequestId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireTemplateId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionnaireFormId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuestionnaireRequestId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQuestionnaireTemplateId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string questionnaire_form_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse.prototype.getQuestionnaireFormId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse} returns this
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse.prototype.setQuestionnaireFormId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string questionnaire_request_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse.prototype.getQuestionnaireRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse} returns this
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse.prototype.setQuestionnaireRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string questionnaire_template_id = 3;
 * @return {string}
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse.prototype.getQuestionnaireTemplateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse} returns this
 */
proto.tprmquestionnaire.CreateQuestionnaireFormInternalResponse.prototype.setQuestionnaireTemplateId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    request: (f = msg.getRequest()) && tprmquestionnaire_tprmquestionnaire_pb.AddVendorQuestionnaireRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest}
 */
proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest;
  return proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest}
 */
proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = new tprmquestionnaire_tprmquestionnaire_pb.AddVendorQuestionnaireRequest;
      reader.readMessage(value,tprmquestionnaire_tprmquestionnaire_pb.AddVendorQuestionnaireRequest.deserializeBinaryFromReader);
      msg.setRequest(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRequest();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      tprmquestionnaire_tprmquestionnaire_pb.AddVendorQuestionnaireRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest} returns this
 */
proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest} returns this
 */
proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional AddVendorQuestionnaireRequest request = 3;
 * @return {?proto.tprmquestionnaire.AddVendorQuestionnaireRequest}
 */
proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest.prototype.getRequest = function() {
  return /** @type{?proto.tprmquestionnaire.AddVendorQuestionnaireRequest} */ (
    jspb.Message.getWrapperField(this, tprmquestionnaire_tprmquestionnaire_pb.AddVendorQuestionnaireRequest, 3));
};


/**
 * @param {?proto.tprmquestionnaire.AddVendorQuestionnaireRequest|undefined} value
 * @return {!proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest} returns this
*/
proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest.prototype.setRequest = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest} returns this
 */
proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest.prototype.clearRequest = function() {
  return this.setRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.AddVendorQuestionnaireInternalRequest.prototype.hasRequest = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.GetQuestionnaireQuestionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.GetQuestionnaireQuestionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    questionnaireFormId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.GetQuestionnaireQuestionsRequest}
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.GetQuestionnaireQuestionsRequest;
  return proto.tprmquestionnaire.GetQuestionnaireQuestionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.GetQuestionnaireQuestionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.GetQuestionnaireQuestionsRequest}
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireFormId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.GetQuestionnaireQuestionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.GetQuestionnaireQuestionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuestionnaireFormId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetQuestionnaireQuestionsRequest} returns this
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string questionnaire_form_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsRequest.prototype.getQuestionnaireFormId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetQuestionnaireQuestionsRequest} returns this
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsRequest.prototype.setQuestionnaireFormId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.tprmquestionnaire.QuestionWithContext.toObject, includeInstance),
    missingContextCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
    direction: jspb.Message.getFieldWithDefault(msg, 3, 0),
    vendorId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    questionnaireRequestId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    questionnaireTitle: jspb.Message.getFieldWithDefault(msg, 6, ""),
    sourceContentId: jspb.Message.getFieldWithDefault(msg, 7, ""),
    sourceFileName: jspb.Message.getFieldWithDefault(msg, 8, ""),
    sourceMimeType: jspb.Message.getFieldWithDefault(msg, 9, ""),
    contentRevision: jspb.Message.getFieldWithDefault(msg, 20, 0),
    originalQuestionsJson: jspb.Message.getFieldWithDefault(msg, 21, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse}
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse;
  return proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse}
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tprmquestionnaire.QuestionWithContext;
      reader.readMessage(value,proto.tprmquestionnaire.QuestionWithContext.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMissingContextCount(value);
      break;
    case 3:
      var value = /** @type {!proto.tprmquestionnaire.QuestionnaireDirection} */ (reader.readEnum());
      msg.setDirection(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setVendorId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireRequestId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireTitle(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceContentId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceFileName(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceMimeType(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setContentRevision(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginalQuestionsJson(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.tprmquestionnaire.QuestionWithContext.serializeBinaryToWriter
    );
  }
  f = message.getMissingContextCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getDirection();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getVendorId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getQuestionnaireRequestId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getQuestionnaireTitle();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSourceContentId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSourceFileName();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSourceMimeType();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getContentRevision();
  if (f !== 0) {
    writer.writeInt64(
      20,
      f
    );
  }
  f = message.getOriginalQuestionsJson();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
};


/**
 * repeated QuestionWithContext items = 1;
 * @return {!Array<!proto.tprmquestionnaire.QuestionWithContext>}
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.QuestionWithContext>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.QuestionWithContext, 1));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.QuestionWithContext>} value
 * @return {!proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse} returns this
*/
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.tprmquestionnaire.QuestionWithContext=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.QuestionWithContext}
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.tprmquestionnaire.QuestionWithContext, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse} returns this
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional int32 missing_context_count = 2;
 * @return {number}
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.prototype.getMissingContextCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse} returns this
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.prototype.setMissingContextCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional QuestionnaireDirection direction = 3;
 * @return {!proto.tprmquestionnaire.QuestionnaireDirection}
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.prototype.getDirection = function() {
  return /** @type {!proto.tprmquestionnaire.QuestionnaireDirection} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.tprmquestionnaire.QuestionnaireDirection} value
 * @return {!proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse} returns this
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.prototype.setDirection = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string vendor_id = 4;
 * @return {string}
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.prototype.getVendorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse} returns this
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.prototype.setVendorId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string questionnaire_request_id = 5;
 * @return {string}
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.prototype.getQuestionnaireRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse} returns this
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.prototype.setQuestionnaireRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string questionnaire_title = 6;
 * @return {string}
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.prototype.getQuestionnaireTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse} returns this
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.prototype.setQuestionnaireTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string source_content_id = 7;
 * @return {string}
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.prototype.getSourceContentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse} returns this
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.prototype.setSourceContentId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string source_file_name = 8;
 * @return {string}
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.prototype.getSourceFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse} returns this
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.prototype.setSourceFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string source_mime_type = 9;
 * @return {string}
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.prototype.getSourceMimeType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse} returns this
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.prototype.setSourceMimeType = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int64 content_revision = 20;
 * @return {number}
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.prototype.getContentRevision = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse} returns this
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.prototype.setContentRevision = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional string original_questions_json = 21;
 * @return {string}
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.prototype.getOriginalQuestionsJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse} returns this
 */
proto.tprmquestionnaire.GetQuestionnaireQuestionsResponse.prototype.setOriginalQuestionsJson = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.QuestionWithContext.repeatedFields_ = [8,11,12,13,14,17,19];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.QuestionWithContext.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.QuestionWithContext} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.QuestionWithContext.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sectionNo: jspb.Message.getFieldWithDefault(msg, 2, 0),
    questionNo: jspb.Message.getFieldWithDefault(msg, 3, 0),
    sectionName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    sectionDescription: jspb.Message.getFieldWithDefault(msg, 5, ""),
    text: jspb.Message.getFieldWithDefault(msg, 6, ""),
    responseType: jspb.Message.getFieldWithDefault(msg, 7, 0),
    optionsList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    context: jspb.Message.getFieldWithDefault(msg, 9, ""),
    rewrittenQuestion: jspb.Message.getFieldWithDefault(msg, 10, ""),
    dependsOnList: jspb.Message.toObjectList(msg.getDependsOnList(),
    tprmquestionnaire_tprmquestionnaire_pb.ConditionRule.toObject, includeInstance),
    sectionDependsOnList: jspb.Message.toObjectList(msg.getSectionDependsOnList(),
    tprmquestionnaire_tprmquestionnaire_pb.ConditionRule.toObject, includeInstance),
    supplementalList: jspb.Message.toObjectList(msg.getSupplementalList(),
    tprmquestionnaire_tprmquestionnaire_pb.SupplementalInput.toObject, includeInstance),
    optionSupplementalList: jspb.Message.toObjectList(msg.getOptionSupplementalList(),
    proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental.toObject, includeInstance),
    hasAnswer: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    answerValue: jspb.Message.getFieldWithDefault(msg, 16, ""),
    answerValuesList: (f = jspb.Message.getRepeatedField(msg, 17)) == null ? undefined : f,
    answerSupplementalText: jspb.Message.getFieldWithDefault(msg, 18, ""),
    attachmentsList: jspb.Message.toObjectList(msg.getAttachmentsList(),
    proto.tprmquestionnaire.QuestionWithContext.Attachment.toObject, includeInstance),
    sourceKey: jspb.Message.getFieldWithDefault(msg, 20, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.QuestionWithContext}
 */
proto.tprmquestionnaire.QuestionWithContext.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.QuestionWithContext;
  return proto.tprmquestionnaire.QuestionWithContext.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.QuestionWithContext} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.QuestionWithContext}
 */
proto.tprmquestionnaire.QuestionWithContext.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSectionNo(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setQuestionNo(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSectionName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSectionDescription(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 7:
      var value = /** @type {!proto.tprmquestionnaire.QuestionResponseType} */ (reader.readEnum());
      msg.setResponseType(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addOptions(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setContext(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setRewrittenQuestion(value);
      break;
    case 11:
      var value = new tprmquestionnaire_tprmquestionnaire_pb.ConditionRule;
      reader.readMessage(value,tprmquestionnaire_tprmquestionnaire_pb.ConditionRule.deserializeBinaryFromReader);
      msg.addDependsOn(value);
      break;
    case 12:
      var value = new tprmquestionnaire_tprmquestionnaire_pb.ConditionRule;
      reader.readMessage(value,tprmquestionnaire_tprmquestionnaire_pb.ConditionRule.deserializeBinaryFromReader);
      msg.addSectionDependsOn(value);
      break;
    case 13:
      var value = new tprmquestionnaire_tprmquestionnaire_pb.SupplementalInput;
      reader.readMessage(value,tprmquestionnaire_tprmquestionnaire_pb.SupplementalInput.deserializeBinaryFromReader);
      msg.addSupplemental(value);
      break;
    case 14:
      var value = new proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental;
      reader.readMessage(value,proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental.deserializeBinaryFromReader);
      msg.addOptionSupplemental(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasAnswer(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnswerValue(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.addAnswerValues(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnswerSupplementalText(value);
      break;
    case 19:
      var value = new proto.tprmquestionnaire.QuestionWithContext.Attachment;
      reader.readMessage(value,proto.tprmquestionnaire.QuestionWithContext.Attachment.deserializeBinaryFromReader);
      msg.addAttachments(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.QuestionWithContext.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.QuestionWithContext} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.QuestionWithContext.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSectionNo();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getQuestionNo();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getSectionName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSectionDescription();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getResponseType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getContext();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getRewrittenQuestion();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getDependsOnList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      tprmquestionnaire_tprmquestionnaire_pb.ConditionRule.serializeBinaryToWriter
    );
  }
  f = message.getSectionDependsOnList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      tprmquestionnaire_tprmquestionnaire_pb.ConditionRule.serializeBinaryToWriter
    );
  }
  f = message.getSupplementalList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      13,
      f,
      tprmquestionnaire_tprmquestionnaire_pb.SupplementalInput.serializeBinaryToWriter
    );
  }
  f = message.getOptionSupplementalList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      14,
      f,
      proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental.serializeBinaryToWriter
    );
  }
  f = message.getHasAnswer();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getAnswerValue();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getAnswerValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      17,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 18));
  if (f != null) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getAttachmentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      19,
      f,
      proto.tprmquestionnaire.QuestionWithContext.Attachment.serializeBinaryToWriter
    );
  }
  f = message.getSourceKey();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental.toObject = function(includeInstance, msg) {
  var f, obj = {
    optionLabel: jspb.Message.getFieldWithDefault(msg, 1, ""),
    supplementalList: jspb.Message.toObjectList(msg.getSupplementalList(),
    tprmquestionnaire_tprmquestionnaire_pb.SupplementalInput.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental}
 */
proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental;
  return proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental}
 */
proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOptionLabel(value);
      break;
    case 2:
      var value = new tprmquestionnaire_tprmquestionnaire_pb.SupplementalInput;
      reader.readMessage(value,tprmquestionnaire_tprmquestionnaire_pb.SupplementalInput.deserializeBinaryFromReader);
      msg.addSupplemental(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOptionLabel();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSupplementalList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      tprmquestionnaire_tprmquestionnaire_pb.SupplementalInput.serializeBinaryToWriter
    );
  }
};


/**
 * optional string option_label = 1;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental.prototype.getOptionLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental.prototype.setOptionLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated SupplementalInput supplemental = 2;
 * @return {!Array<!proto.tprmquestionnaire.SupplementalInput>}
 */
proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental.prototype.getSupplementalList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.SupplementalInput>} */ (
    jspb.Message.getRepeatedWrapperField(this, tprmquestionnaire_tprmquestionnaire_pb.SupplementalInput, 2));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.SupplementalInput>} value
 * @return {!proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental} returns this
*/
proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental.prototype.setSupplementalList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.tprmquestionnaire.SupplementalInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.SupplementalInput}
 */
proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental.prototype.addSupplemental = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.tprmquestionnaire.SupplementalInput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental.prototype.clearSupplementalList = function() {
  return this.setSupplementalList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.QuestionWithContext.Attachment.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.QuestionWithContext.Attachment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.QuestionWithContext.Attachment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.QuestionWithContext.Attachment.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    fileName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    mimeType: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.QuestionWithContext.Attachment}
 */
proto.tprmquestionnaire.QuestionWithContext.Attachment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.QuestionWithContext.Attachment;
  return proto.tprmquestionnaire.QuestionWithContext.Attachment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.QuestionWithContext.Attachment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.QuestionWithContext.Attachment}
 */
proto.tprmquestionnaire.QuestionWithContext.Attachment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMimeType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.QuestionWithContext.Attachment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.QuestionWithContext.Attachment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.QuestionWithContext.Attachment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.QuestionWithContext.Attachment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMimeType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string content_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionWithContext.Attachment.prototype.getContentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionWithContext.Attachment} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.Attachment.prototype.setContentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string file_name = 2;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionWithContext.Attachment.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionWithContext.Attachment} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.Attachment.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string mime_type = 3;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionWithContext.Attachment.prototype.getMimeType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionWithContext.Attachment} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.Attachment.prototype.setMimeType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string question_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.getQuestionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.setQuestionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 section_no = 2;
 * @return {number}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.getSectionNo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.setSectionNo = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 question_no = 3;
 * @return {number}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.getQuestionNo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.setQuestionNo = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string section_name = 4;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.getSectionName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.setSectionName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string section_description = 5;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.getSectionDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.setSectionDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string text = 6;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional QuestionResponseType response_type = 7;
 * @return {!proto.tprmquestionnaire.QuestionResponseType}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.getResponseType = function() {
  return /** @type {!proto.tprmquestionnaire.QuestionResponseType} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.tprmquestionnaire.QuestionResponseType} value
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.setResponseType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * repeated string options = 8;
 * @return {!Array<string>}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.getOptionsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.setOptionsList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.addOptions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.clearOptionsList = function() {
  return this.setOptionsList([]);
};


/**
 * optional string context = 9;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.getContext = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.setContext = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string rewritten_question = 10;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.getRewrittenQuestion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.setRewrittenQuestion = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * repeated ConditionRule depends_on = 11;
 * @return {!Array<!proto.tprmquestionnaire.ConditionRule>}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.getDependsOnList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.ConditionRule>} */ (
    jspb.Message.getRepeatedWrapperField(this, tprmquestionnaire_tprmquestionnaire_pb.ConditionRule, 11));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.ConditionRule>} value
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
*/
proto.tprmquestionnaire.QuestionWithContext.prototype.setDependsOnList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.tprmquestionnaire.ConditionRule=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ConditionRule}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.addDependsOn = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.tprmquestionnaire.ConditionRule, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.clearDependsOnList = function() {
  return this.setDependsOnList([]);
};


/**
 * repeated ConditionRule section_depends_on = 12;
 * @return {!Array<!proto.tprmquestionnaire.ConditionRule>}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.getSectionDependsOnList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.ConditionRule>} */ (
    jspb.Message.getRepeatedWrapperField(this, tprmquestionnaire_tprmquestionnaire_pb.ConditionRule, 12));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.ConditionRule>} value
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
*/
proto.tprmquestionnaire.QuestionWithContext.prototype.setSectionDependsOnList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.tprmquestionnaire.ConditionRule=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.ConditionRule}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.addSectionDependsOn = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.tprmquestionnaire.ConditionRule, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.clearSectionDependsOnList = function() {
  return this.setSectionDependsOnList([]);
};


/**
 * repeated SupplementalInput supplemental = 13;
 * @return {!Array<!proto.tprmquestionnaire.SupplementalInput>}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.getSupplementalList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.SupplementalInput>} */ (
    jspb.Message.getRepeatedWrapperField(this, tprmquestionnaire_tprmquestionnaire_pb.SupplementalInput, 13));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.SupplementalInput>} value
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
*/
proto.tprmquestionnaire.QuestionWithContext.prototype.setSupplementalList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 13, value);
};


/**
 * @param {!proto.tprmquestionnaire.SupplementalInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.SupplementalInput}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.addSupplemental = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.tprmquestionnaire.SupplementalInput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.clearSupplementalList = function() {
  return this.setSupplementalList([]);
};


/**
 * repeated OptionSupplemental option_supplemental = 14;
 * @return {!Array<!proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental>}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.getOptionSupplementalList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental, 14));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental>} value
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
*/
proto.tprmquestionnaire.QuestionWithContext.prototype.setOptionSupplementalList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 14, value);
};


/**
 * @param {!proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.addOptionSupplemental = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 14, opt_value, proto.tprmquestionnaire.QuestionWithContext.OptionSupplemental, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.clearOptionSupplementalList = function() {
  return this.setOptionSupplementalList([]);
};


/**
 * optional bool has_answer = 15;
 * @return {boolean}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.getHasAnswer = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.setHasAnswer = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional string answer_value = 16;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.getAnswerValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.setAnswerValue = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * repeated string answer_values = 17;
 * @return {!Array<string>}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.getAnswerValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 17));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.setAnswerValuesList = function(value) {
  return jspb.Message.setField(this, 17, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.addAnswerValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 17, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.clearAnswerValuesList = function() {
  return this.setAnswerValuesList([]);
};


/**
 * optional string answer_supplemental_text = 18;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.getAnswerSupplementalText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.setAnswerSupplementalText = function(value) {
  return jspb.Message.setField(this, 18, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.clearAnswerSupplementalText = function() {
  return jspb.Message.setField(this, 18, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.hasAnswerSupplementalText = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * repeated Attachment attachments = 19;
 * @return {!Array<!proto.tprmquestionnaire.QuestionWithContext.Attachment>}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.getAttachmentsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.QuestionWithContext.Attachment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.QuestionWithContext.Attachment, 19));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.QuestionWithContext.Attachment>} value
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
*/
proto.tprmquestionnaire.QuestionWithContext.prototype.setAttachmentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 19, value);
};


/**
 * @param {!proto.tprmquestionnaire.QuestionWithContext.Attachment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.QuestionWithContext.Attachment}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.addAttachments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 19, opt_value, proto.tprmquestionnaire.QuestionWithContext.Attachment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.clearAttachmentsList = function() {
  return this.setAttachmentsList([]);
};


/**
 * optional string source_key = 20;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.getSourceKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionWithContext} returns this
 */
proto.tprmquestionnaire.QuestionWithContext.prototype.setSourceKey = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.EnsureQuestionContextRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.EnsureQuestionContextRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.EnsureQuestionContextRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.EnsureQuestionContextRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    questionnaireFormId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.EnsureQuestionContextRequest}
 */
proto.tprmquestionnaire.EnsureQuestionContextRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.EnsureQuestionContextRequest;
  return proto.tprmquestionnaire.EnsureQuestionContextRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.EnsureQuestionContextRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.EnsureQuestionContextRequest}
 */
proto.tprmquestionnaire.EnsureQuestionContextRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireFormId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.EnsureQuestionContextRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.EnsureQuestionContextRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.EnsureQuestionContextRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.EnsureQuestionContextRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuestionnaireFormId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.EnsureQuestionContextRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.EnsureQuestionContextRequest} returns this
 */
proto.tprmquestionnaire.EnsureQuestionContextRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string questionnaire_form_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.EnsureQuestionContextRequest.prototype.getQuestionnaireFormId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.EnsureQuestionContextRequest} returns this
 */
proto.tprmquestionnaire.EnsureQuestionContextRequest.prototype.setQuestionnaireFormId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.WriteAnswerSource.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.WriteAnswerSource.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.WriteAnswerSource} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.WriteAnswerSource.toObject = function(includeInstance, msg) {
  var f, obj = {
    caption: jspb.Message.getFieldWithDefault(msg, 1, ""),
    mime: jspb.Message.getFieldWithDefault(msg, 2, ""),
    hash: jspb.Message.getFieldWithDefault(msg, 3, ""),
    chunkHash: jspb.Message.getFieldWithDefault(msg, 4, ""),
    score: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    referenceId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    referenceType: jspb.Message.getFieldWithDefault(msg, 7, 0),
    contentId: jspb.Message.getFieldWithDefault(msg, 8, ""),
    content: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.WriteAnswerSource}
 */
proto.tprmquestionnaire.WriteAnswerSource.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.WriteAnswerSource;
  return proto.tprmquestionnaire.WriteAnswerSource.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.WriteAnswerSource} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.WriteAnswerSource}
 */
proto.tprmquestionnaire.WriteAnswerSource.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCaption(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMime(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setHash(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setChunkHash(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setScore(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setReferenceId(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setReferenceType(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.WriteAnswerSource.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.WriteAnswerSource.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.WriteAnswerSource} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.WriteAnswerSource.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCaption();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMime();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getHash();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getChunkHash();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getScore();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getReferenceType();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string caption = 1;
 * @return {string}
 */
proto.tprmquestionnaire.WriteAnswerSource.prototype.getCaption = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.WriteAnswerSource} returns this
 */
proto.tprmquestionnaire.WriteAnswerSource.prototype.setCaption = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string mime = 2;
 * @return {string}
 */
proto.tprmquestionnaire.WriteAnswerSource.prototype.getMime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.WriteAnswerSource} returns this
 */
proto.tprmquestionnaire.WriteAnswerSource.prototype.setMime = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string hash = 3;
 * @return {string}
 */
proto.tprmquestionnaire.WriteAnswerSource.prototype.getHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.WriteAnswerSource} returns this
 */
proto.tprmquestionnaire.WriteAnswerSource.prototype.setHash = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string chunk_hash = 4;
 * @return {string}
 */
proto.tprmquestionnaire.WriteAnswerSource.prototype.getChunkHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.WriteAnswerSource} returns this
 */
proto.tprmquestionnaire.WriteAnswerSource.prototype.setChunkHash = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional float score = 5;
 * @return {number}
 */
proto.tprmquestionnaire.WriteAnswerSource.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.WriteAnswerSource} returns this
 */
proto.tprmquestionnaire.WriteAnswerSource.prototype.setScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional string reference_id = 6;
 * @return {string}
 */
proto.tprmquestionnaire.WriteAnswerSource.prototype.getReferenceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.WriteAnswerSource} returns this
 */
proto.tprmquestionnaire.WriteAnswerSource.prototype.setReferenceId = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.WriteAnswerSource} returns this
 */
proto.tprmquestionnaire.WriteAnswerSource.prototype.clearReferenceId = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.WriteAnswerSource.prototype.hasReferenceId = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional int32 reference_type = 7;
 * @return {number}
 */
proto.tprmquestionnaire.WriteAnswerSource.prototype.getReferenceType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.WriteAnswerSource} returns this
 */
proto.tprmquestionnaire.WriteAnswerSource.prototype.setReferenceType = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string content_id = 8;
 * @return {string}
 */
proto.tprmquestionnaire.WriteAnswerSource.prototype.getContentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.WriteAnswerSource} returns this
 */
proto.tprmquestionnaire.WriteAnswerSource.prototype.setContentId = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.WriteAnswerSource} returns this
 */
proto.tprmquestionnaire.WriteAnswerSource.prototype.clearContentId = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.WriteAnswerSource.prototype.hasContentId = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string content = 9;
 * @return {string}
 */
proto.tprmquestionnaire.WriteAnswerSource.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.WriteAnswerSource} returns this
 */
proto.tprmquestionnaire.WriteAnswerSource.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.WriteAnswerAttachment.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.WriteAnswerAttachment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.WriteAnswerAttachment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.WriteAnswerAttachment.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    fileName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    mimeType: jspb.Message.getFieldWithDefault(msg, 3, ""),
    purpose: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.WriteAnswerAttachment}
 */
proto.tprmquestionnaire.WriteAnswerAttachment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.WriteAnswerAttachment;
  return proto.tprmquestionnaire.WriteAnswerAttachment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.WriteAnswerAttachment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.WriteAnswerAttachment}
 */
proto.tprmquestionnaire.WriteAnswerAttachment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMimeType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setPurpose(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.WriteAnswerAttachment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.WriteAnswerAttachment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.WriteAnswerAttachment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.WriteAnswerAttachment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMimeType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPurpose();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string content_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.WriteAnswerAttachment.prototype.getContentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.WriteAnswerAttachment} returns this
 */
proto.tprmquestionnaire.WriteAnswerAttachment.prototype.setContentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string file_name = 2;
 * @return {string}
 */
proto.tprmquestionnaire.WriteAnswerAttachment.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.WriteAnswerAttachment} returns this
 */
proto.tprmquestionnaire.WriteAnswerAttachment.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string mime_type = 3;
 * @return {string}
 */
proto.tprmquestionnaire.WriteAnswerAttachment.prototype.getMimeType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.WriteAnswerAttachment} returns this
 */
proto.tprmquestionnaire.WriteAnswerAttachment.prototype.setMimeType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string purpose = 4;
 * @return {string}
 */
proto.tprmquestionnaire.WriteAnswerAttachment.prototype.getPurpose = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.WriteAnswerAttachment} returns this
 */
proto.tprmquestionnaire.WriteAnswerAttachment.prototype.setPurpose = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.repeatedFields_ = [3,6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.WriteQuestionnaireAnswer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.WriteQuestionnaireAnswer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, ""),
    valuesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    supplementalText: jspb.Message.getFieldWithDefault(msg, 4, ""),
    tiAnswerRationale: jspb.Message.getFieldWithDefault(msg, 5, ""),
    sourcesList: jspb.Message.toObjectList(msg.getSourcesList(),
    proto.tprmquestionnaire.WriteAnswerSource.toObject, includeInstance),
    attachmentsList: jspb.Message.toObjectList(msg.getAttachmentsList(),
    proto.tprmquestionnaire.WriteAnswerAttachment.toObject, includeInstance),
    outcome: jspb.Message.getFieldWithDefault(msg, 8, 0),
    outcomeRationale: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.WriteQuestionnaireAnswer}
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.WriteQuestionnaireAnswer;
  return proto.tprmquestionnaire.WriteQuestionnaireAnswer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.WriteQuestionnaireAnswer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.WriteQuestionnaireAnswer}
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addValues(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSupplementalText(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTiAnswerRationale(value);
      break;
    case 6:
      var value = new proto.tprmquestionnaire.WriteAnswerSource;
      reader.readMessage(value,proto.tprmquestionnaire.WriteAnswerSource.deserializeBinaryFromReader);
      msg.addSources(value);
      break;
    case 7:
      var value = new proto.tprmquestionnaire.WriteAnswerAttachment;
      reader.readMessage(value,proto.tprmquestionnaire.WriteAnswerAttachment.deserializeBinaryFromReader);
      msg.addAttachments(value);
      break;
    case 8:
      var value = /** @type {!proto.tprmquestionnaire.ANSWER_OUTCOME} */ (reader.readEnum());
      msg.setOutcome(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setOutcomeRationale(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.WriteQuestionnaireAnswer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.WriteQuestionnaireAnswer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTiAnswerRationale();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSourcesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.tprmquestionnaire.WriteAnswerSource.serializeBinaryToWriter
    );
  }
  f = message.getAttachmentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.tprmquestionnaire.WriteAnswerAttachment.serializeBinaryToWriter
    );
  }
  f = message.getOutcome();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getOutcomeRationale();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string question_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.getQuestionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.WriteQuestionnaireAnswer} returns this
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.setQuestionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.WriteQuestionnaireAnswer} returns this
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string values = 3;
 * @return {!Array<string>}
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.tprmquestionnaire.WriteQuestionnaireAnswer} returns this
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.WriteQuestionnaireAnswer} returns this
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.WriteQuestionnaireAnswer} returns this
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};


/**
 * optional string supplemental_text = 4;
 * @return {string}
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.getSupplementalText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.WriteQuestionnaireAnswer} returns this
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.setSupplementalText = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tprmquestionnaire.WriteQuestionnaireAnswer} returns this
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.clearSupplementalText = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.hasSupplementalText = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string ti_answer_rationale = 5;
 * @return {string}
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.getTiAnswerRationale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.WriteQuestionnaireAnswer} returns this
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.setTiAnswerRationale = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated WriteAnswerSource sources = 6;
 * @return {!Array<!proto.tprmquestionnaire.WriteAnswerSource>}
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.getSourcesList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.WriteAnswerSource>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.WriteAnswerSource, 6));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.WriteAnswerSource>} value
 * @return {!proto.tprmquestionnaire.WriteQuestionnaireAnswer} returns this
*/
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.setSourcesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.tprmquestionnaire.WriteAnswerSource=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.WriteAnswerSource}
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.addSources = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.tprmquestionnaire.WriteAnswerSource, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.WriteQuestionnaireAnswer} returns this
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.clearSourcesList = function() {
  return this.setSourcesList([]);
};


/**
 * repeated WriteAnswerAttachment attachments = 7;
 * @return {!Array<!proto.tprmquestionnaire.WriteAnswerAttachment>}
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.getAttachmentsList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.WriteAnswerAttachment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.WriteAnswerAttachment, 7));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.WriteAnswerAttachment>} value
 * @return {!proto.tprmquestionnaire.WriteQuestionnaireAnswer} returns this
*/
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.setAttachmentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.tprmquestionnaire.WriteAnswerAttachment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.WriteAnswerAttachment}
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.addAttachments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.tprmquestionnaire.WriteAnswerAttachment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.WriteQuestionnaireAnswer} returns this
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.clearAttachmentsList = function() {
  return this.setAttachmentsList([]);
};


/**
 * optional ANSWER_OUTCOME outcome = 8;
 * @return {!proto.tprmquestionnaire.ANSWER_OUTCOME}
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.getOutcome = function() {
  return /** @type {!proto.tprmquestionnaire.ANSWER_OUTCOME} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.tprmquestionnaire.ANSWER_OUTCOME} value
 * @return {!proto.tprmquestionnaire.WriteQuestionnaireAnswer} returns this
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.setOutcome = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional string outcome_rationale = 9;
 * @return {string}
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.getOutcomeRationale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.WriteQuestionnaireAnswer} returns this
 */
proto.tprmquestionnaire.WriteQuestionnaireAnswer.prototype.setOutcomeRationale = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    questionnaireFormId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    answersList: jspb.Message.toObjectList(msg.getAnswersList(),
    proto.tprmquestionnaire.WriteQuestionnaireAnswer.toObject, includeInstance),
    expectedRevision: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest}
 */
proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest;
  return proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest}
 */
proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireFormId(value);
      break;
    case 3:
      var value = new proto.tprmquestionnaire.WriteQuestionnaireAnswer;
      reader.readMessage(value,proto.tprmquestionnaire.WriteQuestionnaireAnswer.deserializeBinaryFromReader);
      msg.addAnswers(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpectedRevision(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuestionnaireFormId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAnswersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.tprmquestionnaire.WriteQuestionnaireAnswer.serializeBinaryToWriter
    );
  }
  f = message.getExpectedRevision();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest} returns this
 */
proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string questionnaire_form_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest.prototype.getQuestionnaireFormId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest} returns this
 */
proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest.prototype.setQuestionnaireFormId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated WriteQuestionnaireAnswer answers = 3;
 * @return {!Array<!proto.tprmquestionnaire.WriteQuestionnaireAnswer>}
 */
proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest.prototype.getAnswersList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.WriteQuestionnaireAnswer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.WriteQuestionnaireAnswer, 3));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.WriteQuestionnaireAnswer>} value
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest} returns this
*/
proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest.prototype.setAnswersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.tprmquestionnaire.WriteQuestionnaireAnswer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.WriteQuestionnaireAnswer}
 */
proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest.prototype.addAnswers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.tprmquestionnaire.WriteQuestionnaireAnswer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest} returns this
 */
proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest.prototype.clearAnswersList = function() {
  return this.setAnswersList([]);
};


/**
 * optional int64 expected_revision = 4;
 * @return {number}
 */
proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest.prototype.getExpectedRevision = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest} returns this
 */
proto.tprmquestionnaire.SaveQuestionnaireAnswersRequest.prototype.setExpectedRevision = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.SaveQuestionnaireAnswersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.SaveQuestionnaireAnswersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.SaveQuestionnaireAnswersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SaveQuestionnaireAnswersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    savedCount: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireAnswersResponse}
 */
proto.tprmquestionnaire.SaveQuestionnaireAnswersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.SaveQuestionnaireAnswersResponse;
  return proto.tprmquestionnaire.SaveQuestionnaireAnswersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.SaveQuestionnaireAnswersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireAnswersResponse}
 */
proto.tprmquestionnaire.SaveQuestionnaireAnswersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSavedCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.SaveQuestionnaireAnswersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.SaveQuestionnaireAnswersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.SaveQuestionnaireAnswersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SaveQuestionnaireAnswersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSavedCount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 saved_count = 1;
 * @return {number}
 */
proto.tprmquestionnaire.SaveQuestionnaireAnswersResponse.prototype.getSavedCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireAnswersResponse} returns this
 */
proto.tprmquestionnaire.SaveQuestionnaireAnswersResponse.prototype.setSavedCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.QuestionnaireAnswerGrade.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.QuestionnaireAnswerGrade.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.QuestionnaireAnswerGrade.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.QuestionnaireAnswerGrade} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.QuestionnaireAnswerGrade.toObject = function(includeInstance, msg) {
  var f, obj = {
    questionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    confidence: jspb.Message.getFieldWithDefault(msg, 2, 0),
    confidenceReason: jspb.Message.getFieldWithDefault(msg, 3, ""),
    appropriateness: jspb.Message.getFieldWithDefault(msg, 4, 0),
    appropriatenessReason: jspb.Message.getFieldWithDefault(msg, 5, ""),
    sourcesList: jspb.Message.toObjectList(msg.getSourcesList(),
    proto.tprmquestionnaire.WriteAnswerSource.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.QuestionnaireAnswerGrade}
 */
proto.tprmquestionnaire.QuestionnaireAnswerGrade.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.QuestionnaireAnswerGrade;
  return proto.tprmquestionnaire.QuestionnaireAnswerGrade.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.QuestionnaireAnswerGrade} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.QuestionnaireAnswerGrade}
 */
proto.tprmquestionnaire.QuestionnaireAnswerGrade.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionId(value);
      break;
    case 2:
      var value = /** @type {!proto.tprmquestionnaire.GRADE_BAND} */ (reader.readEnum());
      msg.setConfidence(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfidenceReason(value);
      break;
    case 4:
      var value = /** @type {!proto.tprmquestionnaire.GRADE_BAND} */ (reader.readEnum());
      msg.setAppropriateness(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppropriatenessReason(value);
      break;
    case 6:
      var value = new proto.tprmquestionnaire.WriteAnswerSource;
      reader.readMessage(value,proto.tprmquestionnaire.WriteAnswerSource.deserializeBinaryFromReader);
      msg.addSources(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.QuestionnaireAnswerGrade.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.QuestionnaireAnswerGrade.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.QuestionnaireAnswerGrade} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.QuestionnaireAnswerGrade.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuestionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConfidence();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getConfidenceReason();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAppropriateness();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getAppropriatenessReason();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSourcesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.tprmquestionnaire.WriteAnswerSource.serializeBinaryToWriter
    );
  }
};


/**
 * optional string question_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireAnswerGrade.prototype.getQuestionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireAnswerGrade} returns this
 */
proto.tprmquestionnaire.QuestionnaireAnswerGrade.prototype.setQuestionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional GRADE_BAND confidence = 2;
 * @return {!proto.tprmquestionnaire.GRADE_BAND}
 */
proto.tprmquestionnaire.QuestionnaireAnswerGrade.prototype.getConfidence = function() {
  return /** @type {!proto.tprmquestionnaire.GRADE_BAND} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.tprmquestionnaire.GRADE_BAND} value
 * @return {!proto.tprmquestionnaire.QuestionnaireAnswerGrade} returns this
 */
proto.tprmquestionnaire.QuestionnaireAnswerGrade.prototype.setConfidence = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string confidence_reason = 3;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireAnswerGrade.prototype.getConfidenceReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireAnswerGrade} returns this
 */
proto.tprmquestionnaire.QuestionnaireAnswerGrade.prototype.setConfidenceReason = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional GRADE_BAND appropriateness = 4;
 * @return {!proto.tprmquestionnaire.GRADE_BAND}
 */
proto.tprmquestionnaire.QuestionnaireAnswerGrade.prototype.getAppropriateness = function() {
  return /** @type {!proto.tprmquestionnaire.GRADE_BAND} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.tprmquestionnaire.GRADE_BAND} value
 * @return {!proto.tprmquestionnaire.QuestionnaireAnswerGrade} returns this
 */
proto.tprmquestionnaire.QuestionnaireAnswerGrade.prototype.setAppropriateness = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string appropriateness_reason = 5;
 * @return {string}
 */
proto.tprmquestionnaire.QuestionnaireAnswerGrade.prototype.getAppropriatenessReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.QuestionnaireAnswerGrade} returns this
 */
proto.tprmquestionnaire.QuestionnaireAnswerGrade.prototype.setAppropriatenessReason = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated WriteAnswerSource sources = 6;
 * @return {!Array<!proto.tprmquestionnaire.WriteAnswerSource>}
 */
proto.tprmquestionnaire.QuestionnaireAnswerGrade.prototype.getSourcesList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.WriteAnswerSource>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.WriteAnswerSource, 6));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.WriteAnswerSource>} value
 * @return {!proto.tprmquestionnaire.QuestionnaireAnswerGrade} returns this
*/
proto.tprmquestionnaire.QuestionnaireAnswerGrade.prototype.setSourcesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.tprmquestionnaire.WriteAnswerSource=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.WriteAnswerSource}
 */
proto.tprmquestionnaire.QuestionnaireAnswerGrade.prototype.addSources = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.tprmquestionnaire.WriteAnswerSource, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.QuestionnaireAnswerGrade} returns this
 */
proto.tprmquestionnaire.QuestionnaireAnswerGrade.prototype.clearSourcesList = function() {
  return this.setSourcesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.tprmquestionnaire.SaveQuestionnaireGradesRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.SaveQuestionnaireGradesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.SaveQuestionnaireGradesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.SaveQuestionnaireGradesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SaveQuestionnaireGradesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    questionnaireFormId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    gradesList: jspb.Message.toObjectList(msg.getGradesList(),
    proto.tprmquestionnaire.QuestionnaireAnswerGrade.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireGradesRequest}
 */
proto.tprmquestionnaire.SaveQuestionnaireGradesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.SaveQuestionnaireGradesRequest;
  return proto.tprmquestionnaire.SaveQuestionnaireGradesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.SaveQuestionnaireGradesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireGradesRequest}
 */
proto.tprmquestionnaire.SaveQuestionnaireGradesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuestionnaireFormId(value);
      break;
    case 3:
      var value = new proto.tprmquestionnaire.QuestionnaireAnswerGrade;
      reader.readMessage(value,proto.tprmquestionnaire.QuestionnaireAnswerGrade.deserializeBinaryFromReader);
      msg.addGrades(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.SaveQuestionnaireGradesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.SaveQuestionnaireGradesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.SaveQuestionnaireGradesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SaveQuestionnaireGradesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuestionnaireFormId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGradesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.tprmquestionnaire.QuestionnaireAnswerGrade.serializeBinaryToWriter
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.tprmquestionnaire.SaveQuestionnaireGradesRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireGradesRequest} returns this
 */
proto.tprmquestionnaire.SaveQuestionnaireGradesRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string questionnaire_form_id = 2;
 * @return {string}
 */
proto.tprmquestionnaire.SaveQuestionnaireGradesRequest.prototype.getQuestionnaireFormId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireGradesRequest} returns this
 */
proto.tprmquestionnaire.SaveQuestionnaireGradesRequest.prototype.setQuestionnaireFormId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated QuestionnaireAnswerGrade grades = 3;
 * @return {!Array<!proto.tprmquestionnaire.QuestionnaireAnswerGrade>}
 */
proto.tprmquestionnaire.SaveQuestionnaireGradesRequest.prototype.getGradesList = function() {
  return /** @type{!Array<!proto.tprmquestionnaire.QuestionnaireAnswerGrade>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.tprmquestionnaire.QuestionnaireAnswerGrade, 3));
};


/**
 * @param {!Array<!proto.tprmquestionnaire.QuestionnaireAnswerGrade>} value
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireGradesRequest} returns this
*/
proto.tprmquestionnaire.SaveQuestionnaireGradesRequest.prototype.setGradesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.tprmquestionnaire.QuestionnaireAnswerGrade=} opt_value
 * @param {number=} opt_index
 * @return {!proto.tprmquestionnaire.QuestionnaireAnswerGrade}
 */
proto.tprmquestionnaire.SaveQuestionnaireGradesRequest.prototype.addGrades = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.tprmquestionnaire.QuestionnaireAnswerGrade, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireGradesRequest} returns this
 */
proto.tprmquestionnaire.SaveQuestionnaireGradesRequest.prototype.clearGradesList = function() {
  return this.setGradesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tprmquestionnaire.SaveQuestionnaireGradesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.tprmquestionnaire.SaveQuestionnaireGradesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tprmquestionnaire.SaveQuestionnaireGradesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SaveQuestionnaireGradesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    savedCount: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireGradesResponse}
 */
proto.tprmquestionnaire.SaveQuestionnaireGradesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tprmquestionnaire.SaveQuestionnaireGradesResponse;
  return proto.tprmquestionnaire.SaveQuestionnaireGradesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tprmquestionnaire.SaveQuestionnaireGradesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireGradesResponse}
 */
proto.tprmquestionnaire.SaveQuestionnaireGradesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSavedCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tprmquestionnaire.SaveQuestionnaireGradesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tprmquestionnaire.SaveQuestionnaireGradesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tprmquestionnaire.SaveQuestionnaireGradesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tprmquestionnaire.SaveQuestionnaireGradesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSavedCount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 saved_count = 1;
 * @return {number}
 */
proto.tprmquestionnaire.SaveQuestionnaireGradesResponse.prototype.getSavedCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.tprmquestionnaire.SaveQuestionnaireGradesResponse} returns this
 */
proto.tprmquestionnaire.SaveQuestionnaireGradesResponse.prototype.setSavedCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * @enum {number}
 */
proto.tprmquestionnaire.ImportDestination = {
  IMPORT_DESTINATION_TEMPLATE: 0,
  IMPORT_DESTINATION_RECEIVED: 1
};

/**
 * @enum {number}
 */
proto.tprmquestionnaire.QuestionnaireDirection = {
  DIRECTION_UNSPECIFIED: 0,
  DIRECTION_INBOUND: 1,
  DIRECTION_OUTBOUND: 2
};

/**
 * @enum {number}
 */
proto.tprmquestionnaire.ANSWER_OUTCOME = {
  ANSWER_OUTCOME_UNSPECIFIED: 0,
  ANSWER_OUTCOME_ANSWERED: 1,
  ANSWER_OUTCOME_PARTIAL: 2,
  ANSWER_OUTCOME_UNANSWERABLE: 3
};

goog.object.extend(exports, proto.tprmquestionnaire);
